module.exports = __webpack_public_path__ + "img/ethnic.999aea5a.jpg";